var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("FinanceManage.DetailedEntryRulesConfiguration"),
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        width: "440px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          model: {
            value: _vm.form,
            callback: function($$v) {
              _vm.form = $$v
            },
            expression: "form"
          }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isStep1,
                  expression: "isStep1"
                }
              ]
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "2px !important" },
                  attrs: { "label-width": "0" }
                },
                [
                  _c(
                    "div",
                    {
                      style: {
                        display: "inline-block",
                        width: _vm.$selectByLang(
                          "100px",
                          "120px",
                          "120px",
                          "120px",
                          "120px",
                          "120px"
                        ),
                        marginRight: "20px",
                        textAlign: "right"
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_VoucherGroupingType"))
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      on: { change: _vm.checkAvailableEntryTypes },
                      model: {
                        value: _vm.form.accountingDocumentRuleUuid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "accountingDocumentRuleUuid", $$v)
                        },
                        expression: "form.accountingDocumentRuleUuid"
                      }
                    },
                    _vm._l(_vm.accountingDocumentsRules, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.uuid, label: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "2px !important" },
                  attrs: { "label-width": "0" }
                },
                [
                  _c(
                    "div",
                    {
                      style: {
                        display: "inline-block",
                        width: _vm.$selectByLang(
                          "100px",
                          "120px",
                          "120px",
                          "120px",
                          "120px",
                          "120px"
                        ),
                        marginRight: "20px",
                        textAlign: "right"
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "CargoMsg.Cargo_GroupingTypesOfJournalEntries"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      model: {
                        value: _vm.form.entryRuleUuid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "entryRuleUuid", $$v)
                        },
                        expression: "form.entryRuleUuid"
                      }
                    },
                    _vm._l(_vm.entryRules, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.uuid, label: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isStep1,
                  expression: "!isStep1"
                }
              ]
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "justify-content": "flex-start" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "260px" },
                      attrs: { label: _vm.$t("CargoMsg.Cargo_IndexName") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.form.defaultSummary,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "defaultSummary", $$v)
                          },
                          expression: "form.defaultSummary"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.enableSummaryDimensionOrder,
                          expression: "enableSummaryDimensionOrder"
                        }
                      ],
                      staticStyle: { width: "120px", "padding-left": "5px" },
                      attrs: { label: _vm.$t("CargoMsg.Cargo_SequenceNumber") }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "60px" },
                        attrs: { min: 0, precision: 0, controls: false },
                        on: {
                          blur: function(e) {
                            if (e.target.value < 0) {
                              _vm.form.sequenceNo = undefined
                            }
                          }
                        },
                        model: {
                          value: _vm.form.sequenceNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "sequenceNo", $$v)
                          },
                          expression: "form.sequenceNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.enableSummaryDimensionOrder,
                      expression: "enableSummaryDimensionOrder"
                    }
                  ],
                  staticClass: "app-main-inner-row",
                  staticStyle: { "justify-content": "flex-start" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "260px" },
                      attrs: { label: _vm.$t("CargoMsg.Cargo_IndexName") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.form.secondSummary,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondSummary", $$v)
                          },
                          expression: "form.secondSummary"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "120px", "padding-left": "5px" },
                      attrs: { label: _vm.$t("CargoMsg.Cargo_SequenceNumber") }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "60px" },
                        attrs: { min: 0, precision: 0, controls: false },
                        on: {
                          blur: function(e) {
                            if (e.target.value < 0) {
                              _vm.form.secondSequenceNo = undefined
                            }
                          }
                        },
                        model: {
                          value: _vm.form.secondSequenceNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "secondSequenceNo", $$v)
                          },
                          expression: "form.secondSequenceNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "app-main-inner-row row-grid" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        return (_vm.gridApi = params.api)
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _vm.isStep1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.nextStepHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.next")))]
              )
            : _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveHandler } },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }